module.exports = __webpack_public_path__ + "static/media/night02.085f9a8a.jpeg";